import { useEffect } from 'react';

const SCRIPT_ID = 'Freshdesk-js-sdk';

function getConfig() {
  return {
    host: process.env.REACT_APP_FRESHDESK_HOST,
    token: process.env.REACT_APP_FRESHDESK_TOKEN,
    widgetId: process.env.REACT_APP_FRESHDESK_WIDGET_ID,
  };
}

/**
 * Loads Freshdesk Web Chat on main app shell only (see Main layout).
 * Cleans up when leaving main routes so blank/auth layouts do not show the widget.
 */
export default function FreshdeskWebChat() {
  useEffect(() => {
    const { host, token, widgetId } = getConfig();
    const baseHost = host?.replace(/\/$/, '');

    function initFreshdesk() {
      if (window.fdWidget && typeof window.fdWidget.init === 'function') {
        window.fdWidget.init({ token, host: baseHost, widgetId });
      }
    }

    if (document.getElementById(SCRIPT_ID)) {
      initFreshdesk();
    } else {
      const script = document.createElement('script');
      script.id = SCRIPT_ID;
      script.async = true;
      script.src = `${baseHost}/webchat/js/widget.js`;
      script.onload = initFreshdesk;
      document.head.appendChild(script);
    }

    return () => {
      if (window.fdWidget && typeof window.fdWidget.destroy === 'function') {
        window.fdWidget.destroy();
      }
    };
  }, []);

  return null;
}
